import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import ExamRegistrationsListing from '../../modules/examRegistration/components/ExamRegistrationsListing';

const Listing = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('exam->>ViewRegisteredExamsListing.RegisteredExams')} />
      <ExamRegistrationsListing />
    </>
  );
};

export default Listing;
